<template>
    <div class="event">
        <section class="section">
            <div class="container">
                <b-tabs position="is-centered" type="is-boxed" v-model="$root.env.view.activeTab">
                    <b-tab-item :label="$l.dashboard" icon="tachometer-alt" icon-pack="fad"></b-tab-item>
                    <b-tab-item :label="$l.arrangement" icon="calendar-day" icon-pack="fad"></b-tab-item>
                    <b-tab-item :label="$l.communication" icon="envelope" icon-pack="fad"></b-tab-item>
                    <b-tab-item :label="$l.participants" icon="users" icon-pack="fad"></b-tab-item>
                    <b-tab-item :label="$l.registration" icon="user-check" icon-pack="fad"></b-tab-item>

                </b-tabs>
                <div class="trans-parent-event">
                    <transition :name="transition">
                        <Dashboard v-if="$root.env.view.activeTab == 0"/>
                        <Arrangement v-if="$root.env.view.activeTab == 1"/>
                        <Communication v-if="$root.env.view.activeTab == 2"/>
                        <Users v-if="$root.env.view.activeTab == 3"/>
                        <Registration v-if="$root.env.view.activeTab == 4"/>
                    </transition>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    // @ is an alias to /src
    import Navbar from '@/components/Navbar.vue'
    import Dashboard from '@/components/Events/Dashboard.vue'
    import Arrangement from '@/components/Events/Arrangement.vue'
    import Communication from '@/components/Events/Communication.vue'
    import Users from '@/components/Events/Users.vue'
    import Registration from '@/components/Events/Registration.vue'

    export default {
        name: 'event',
        props: {
            env: Object
        },
        data() {
            return {
                eventname: 'test',
                oldTab: 0,
                transition: 'slide-left'
            }
        },
        components: {
            Navbar,
            Users,
            Dashboard,
            Registration,
            Communication,
            Arrangement
        },
        created() {
            // fetch the data when the view is created and the data is
            // already being observed
            if (this.$route.params.page) {
                this.$root.env.view.activeTab = this.$root.env.view.tabMapping.indexOf('/' + this.$route.params.page)
                if (this.$root.env.view.activeTab < 0) {
                    this.$root.env.view.activeTab = 0
                    this.updateTab()
                }
            }
            this.$root.getSettings()
            this.$root.getEvents()
            this.$root.getUsers(this.$route.params.id)
            this.$root.getAccount()
            this.update()
        },
        methods: {
            update(id = this.$route.params.id) {
                this.$root.getEvent(id)
            },
            updateTab() {
                // console.log(this.$router)
                if (this.$root.env.view.activeTab >= this.$root.env.view.tabMapping.length) {
                    this.$root.env.view.activeTab = this.oldTab
                    return true
                }
                this.transition = this.oldTab < this.$root.env.view.activeTab ? 'slide-left' : 'slide-right'
                this.oldTab = this.$root.env.view.activeTab
                this.$router.push({path: '/event/' + this.$route.params.id + this.$root.env.view.tabMapping[this.$root.env.view.activeTab]})
            }
        },
        watch: {
            // call again the method if the route changes
            // '$route': 'update',
            '$root.env.view.activeTab': 'updateTab',
        },
        computed: {
            $activeTab() {

            }
        }
    }
</script>

<style>

    .trans-parent-event {
        position: relative;
    }

    .trans-parent-event > div {
        width: 100%;
        position: absolute;
    }

    /* Enter and leave animations can use different */
    /* durations and timing functions.              */
    .slide-right-enter-active,
    .slide-left-enter-active {
        transition: all .3s ease-in;
    }

    .slide-right-leave-active,
    .slide-left-leave-active {
        transition: all .8s ease-out;
    }

    .slide-right-enter, .slide-left-leave-to
        /* .slide-fade-leave-active below version 2.1.8 */
    {
        transform: translateX(-10px);
        opacity: 0;
    }

    .slide-left-enter, .slide-right-leave-to
        /* .slide-fade-leave-active below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }

    .draggy,
    .draggyLabel label.label{
        cursor: move;
    }

</style>
